import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";
import ExperiencePageContent from "../components/experience/experience-page";

const ExperiencePage = () => {
  return (
    <Layout>
      <ExperiencePageContent />
    </Layout>
  );
};

export default ExperiencePage;

export const Head = () => <Seo title="Experience" />;